import React, { useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonGroup } from 'reactstrap';

function createNumberArray(from = 1, to = 4) {
    return Array.from(Array(to + 1).keys()).filter(n => n >= from)
}

const defaultColor = '';

function Pagination({ page: currentPage, total, isDisabled, onPrevPage, onNextPage, onPageClick, color = defaultColor }) {
    const { t } = useTranslation()

    const pages = useMemo(() => {
        let list = []
        if (currentPage < 5) {
            list = createNumberArray(1, Math.min(total, 10))
            if (total > 10) {
                list.push('...')
                list.push(total)
            }
            return list;
        }

        list = [
            1,
            '...',
            ...createNumberArray(currentPage - 4, Math.min(currentPage + 4, total))
        ]
        if (total > 10 && total - currentPage > 4) {
            list.push('...')
            list.push(total)
        }


        return list
    }, [currentPage, total])

    const handlePageClick = useCallback((page) => () => {
        onPageClick(page)
    }, [onPageClick])


    return (
        <ButtonGroup size="sm" color={color} className="paginator">
            <Button
                color={color}
                disabled={Number(currentPage) === 1 || isDisabled}
                onClick={onPrevPage}
            >
                <i className="fas fa-caret-left"></i>
            </Button>
            {pages?.map((page, i) => <Button
                color={color}
                key={`${page}-${i}`} href="#"
                active={page === currentPage}
                onClick={handlePageClick(!isNaN(page) ? page : currentPage)}>{page}</Button>
            )}
            <Button
                color={color}
                disabled={Number(currentPage) === Number(total) || isDisabled}
                onClick={onNextPage}
            >
                <i className="fas fa-caret-right"></i>
            </Button>
        </ButtonGroup>
    )
}

export default Pagination;